export type Lang = 'cn' | 'en';
export const LANGS: readonly Lang[] = ['cn', 'en'] as const;
